"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alignLegends = alignLegends;
exports.getComputedHeight = getComputedHeight;
exports.getOptions = getOptions;
exports.rotateBottomTicks = rotateBottomTicks;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function alignLegends(chart) {
  let ticks = chart.querySelector('.ticks');
  let rect = ticks.getBoundingClientRect();
  const {
    width
  } = rect;
  const legend = chart.querySelector('.cds--cc--legend');
  legend.style.marginLeft = `${width}px`;
}
function rotateBottomTicks(chartRef) {
  let bottomAxisTickGroups = chartRef.querySelectorAll('.axis.bottom .ticks');
  bottomAxisTickGroups.forEach(bottomAxis => {
    let ticks = bottomAxis.querySelectorAll('.tick');
    ticks.forEach(tick => {
      let text = tick.querySelector('text');
      let {
        x,
        y
      } = text.getBBox();
      text.setAttribute('transform', `rotate(-90,${-1 * x},${y})`);
    });
  });
}
function getComputedHeight(chartRef, bandWidth, data, dataGrouping) {
  if (!chartRef) {
    const INITIAL_HEIGHT = '400PX';
    return INITIAL_HEIGHT;
  }
  let {
    height: leftAxisHeight
  } = chartRef.querySelector('.axis.left').getBBox();
  let {
    height: bottomAxisHeight
  } = chartRef.querySelector('.axis.bottom').getBBox();
  let bottomAxisLabelHeight = bottomAxisHeight - leftAxisHeight;
  let holderRect = chartRef.getBoundingClientRect();
  let rect = chartRef?.querySelector('.legend')?.getBoundingClientRect() || {
    height: 0
  };
  const EXTRA_HEIGHT = holderRect.height - bottomAxisHeight - rect.height;
  let computedHeight = bandWidth * data.length / dataGrouping + EXTRA_HEIGHT + bottomAxisLabelHeight + rect.height + 'px';
  return computedHeight;
}
function getOptions(overridingOptions, translate, isMobile, width) {
  let defaultOptions = {
    title: '',
    axes: {
      left: {
        scaleType: 'labels',
        mapsTo: 'key',
        truncation: {
          threshold: isMobile ? 10 : 100,
          numCharacter: isMobile ? 10 : 100
        }
      },
      bottom: {
        mapsTo: 'value',
        ticks: {
          rotation: width < 672 ? "always" : "never"
        }
      }
    },
    grid: {
      x: {
        alignWithAxisTicks: true
      }
    },
    toolbar: {
      enabled: false
    },
    bars: {
      width: 10,
      maxWidth: 10
    },
    tooltip: {
      enabled: true,
      customHTML: (data, defaultHTML) => {
        let translatedHTML = defaultHTML.replace('Group', translate('benchmarking.barchart.tooltip.group')).replace('x-value', translate('benchmarking.barchart.tooltip.x-value')).replace('y-value', translate('benchmarking.barchart.tooltip.y-value'));
        return translatedHTML;
      }
    }
  };
  let options = _lodash.default.merge(defaultOptions, overridingOptions);
  return options;
}